import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_tac" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h4 _flex _ai-c _jc-c _mb-1" }
const _hoisted_3 = { class: "gfu-bt--caption" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h2 _my-0 _tc--dark" }
const _hoisted_5 = { "data-qa": "project-summary-box:EndgameExtendedAmount" }
const _hoisted_6 = { class: "_mb-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "gfu-hd--h2 _my-0 _flexinline",
  "data-qa": "project-summary:EndgameTimer"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "gfu-bt--caption _mt-1 _fw-b" }
const _hoisted_12 = { class: "gfu-bt--caption" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_animated_number = _resolveComponent("animated-number")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_timer_component = _resolveComponent("timer-component")
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_box = _resolveComponent("box")
  const _component_base_avatar = _resolveComponent("base-avatar")
  const _component_project_summary_box = _resolveComponent("project-summary-box")

  return (_openBlock(), _createBlock(_component_project_summary_box, {
    borderless: "",
    class: "gfu-project-summary-overtime-card _tac _fo",
    "data-qa": "project-summary-box:Endgame"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, [
          _createVNode(_component_base_icon, {
            size: "lg",
            class: "_tc--urgent _mr-1",
            name: "arrow-right-from-line"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeTitle), 1 /* TEXT */)
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeExplanationParagraph), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_4, [
          _createVNode(_component_display_currency_value, { tag: "span" }, {
            content: _withCtx(({ displayCurrency }) => [
              _createVNode(_component_animated_number, {
                tag: "h3",
                class: "gfu-hd gfu-hd--h2 _flexinline",
                number: $options.roundToIntegers($options.fundsGathered / displayCurrency.relativeFactor),
                format: "C0",
                "currency-symbol": displayCurrency.symbol
              }, null, 8 /* PROPS */, ["number", "currency-symbol"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_animated_number, {
                tag: "h3",
                class: "gfu-hd gfu-hd--h2 _flexinline",
                number: $options.fundsGatheredFormatted,
                format: "C0"
              }, null, 8 /* PROPS */, ["number"])
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeFoundedLabel), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_display_currency_value, { tag: "span" }, {
            content: _withCtx(({ displayCurrency }) => [
              _createVNode(_component_animated_number, {
                tag: "span",
                class: "_flexinline",
                number: $options.roundToIntegers($options.fundsGatheredOvertime / displayCurrency.relativeFactor),
                format: "C0",
                "currency-symbol": displayCurrency.symbol
              }, null, 8 /* PROPS */, ["number", "currency-symbol"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_animated_number, {
                tag: "span",
                class: "_flexinline",
                number: $options.fundsGatheredOvertimeFormatted,
                format: "C0"
              }, null, 8 /* PROPS */, ["number"])
            ]),
            _: 1 /* STABLE */
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeExtendedTimeLabel), 1 /* TEXT */)
        ])
      ]),
      _createVNode(_component_box, {
        slim: "",
        class: "_bgc--urgent _flexcol _tc--white gfu-flash _jc-c _ai-c"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_timer_component, {
              timestamp: $options.campaignEndToDate,
              class: "_mt-a",
              onCountdownFinished: $options.refreshPage
            }, {
              default: _withCtx(({ seconds, minutes, shouldStopCounting }) => [
                (!shouldStopCounting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeTimerText), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("h2", _hoisted_8, [
                  shouldStopCounting
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeTimerElapsedText), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(minutes) + " " + _toDisplayString(_ctx.Resources.pluralize(minutes, _ctx.Resources.ProjectHome.HumanizeDatePluralizedMinuteShort)) + " " + _toDisplayString(seconds) + " " + _toDisplayString(_ctx.Resources.pluralize(seconds, _ctx.Resources.ProjectHome.HumanizeDatePluralizedSecondShort)), 1 /* TEXT */))
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["timestamp", "onCountdownFinished"])
          ]),
          _createVNode(_component_tooltip, {
            text: _ctx.Resources.ProjectHome.CrowdfundingExpressUpgradeLimitationText,
            enabled: !$options.canEditPledgeItems,
            class: "_w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_back_project_button, {
                theme: "default",
                class: "gfu-project-summary-action gfu-btn--urgent-alt _bxsh--base _bgc--white _tc--urgent",
                disabled: !$options.canEditPledgeItems,
                "data-qa": "project-summary:BackNow"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.buttonLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text", "enabled"]),
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeTooltipTriggerText) + " ", 1 /* TEXT */),
            _createVNode(_component_tooltip, {
              "icon-name": "circle-info",
              text: $options.tooltipMessage
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_12, [
        (!$options.hasOvertimeBackers)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeBackersEmptyStateText), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeExtendedText2) + " ", 1 /* TEXT */),
              _createElementVNode("strong", null, _toDisplayString($options.campaignExtendedBy), 1 /* TEXT */),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.ProjectOvertimeExtendedText1) + " ", 1 /* TEXT */),
              _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.pluralize($options.backersCountOvertime, _ctx.Resources.ProjectHome.ProjectSummaryProgressPluralizedBacker)), 1 /* TEXT */),
              _cache[1] || (_cache[1] = _createTextVNode(". ", -1 /* CACHED */))
            ])),
        _createElementVNode("div", {
          ref: "avatarStackContainer",
          class: _normalizeClass($options.avatarStackContainerClasses)
        }, [
          _createVNode(_TransitionGroup, {
            class: _normalizeClass($options.avatarListClasses),
            name: "gfu-avatar-stack-container",
            tag: "div"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.displayedBackers, (backer) => {
                return (_openBlock(), _createBlock(_component_base_avatar, {
                  key: backer.userID,
                  class: "gfu-avatar-stack-container__item _-mr-1",
                  size: "xxs",
                  bordered: "",
                  "avatar-url": backer.userAvatarImageUrl,
                  "avatar-nickname": backer.userNickname
                }, null, 8 /* PROPS */, ["avatar-url", "avatar-nickname"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"])
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("button", {
        class: "gfu-project-card__action-button",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleShowDetails && $options.toggleShowDetails(...args)))
      }, [
        _createVNode(_component_base_icon, {
          class: "_pa-1",
          "icon-namespace": "ga",
          name: "revert"
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}